<script setup>
    import { useScheduleItemStore } from "@/stores/ScheduleItemStore"
    import { computed } from "vue";
    import ClearFiltersButton from "./ClearFiltersButton.vue";

    const store = useScheduleItemStore()

    const clearFilters = () => {
        store.clearAllFilters()
    }

    const currentSession = computed(() => {
        return store.generalSessions.find( (gs) => {
            return gs.slug === store.currentFilters.session
        })
    })

    const currentWorkshop = computed(() => {
        return store.workshops.find( (ws) => {
            return ws.slug === store.currentFilters.workshop
        })
    })

    const currentLocation = computed(() => {
        return store.locations.find( (loc) => {
            return loc.id === store.currentFilters.location
        })
    })

    const moderatorsByDay = ( gs_programme ) => {
        const result = []
        Object.keys( gs_programme ).forEach( ( day ) => {
            gs_programme[ day ].forEach( ( presentation ) => {
                if ( presentation.moderators ) {
                    result.push( { day: day, start: presentation.startTimeInText, moderators: presentation.moderators })
                }
            })
        })
        return result
    }
    
</script>
<template>
    
    <template v-if="store.view === 'favs'" >
        <div class="sles__active-filter-heading sles__active-filter-heading--favs">
            <h2 class="sles__active-filter-heading__title">Bookmarks</h2>
        </div>
    </template>

    <template v-if="store.currentFilters.search !== ''" >
        <div class="sles__active-filter-heading sles__active-filter-heading--search">
            <h2 class="sles__active-filter-heading__title">You've searched for "<em>{{store.currentFilters.search}}</em>"</h2>
            <div class="sles__active-filter-heading__info">
                <span
                    class="clear-all-filters"
                    @click.prevent="clearFilters()"
                >Clear search</span>
            </div>
        </div>
    </template>

    <template v-if="store.currentFilters.location && store.currentFilters.location !== ''" >
        <div class="sles__active-filter-heading sles__active-filter-heading--location">
            <h2 class="sles__active-filter-heading__title">{{ currentLocation.title }}</h2>
            <div class="sles__active-filter-heading__info">
                <div v-if="currentLocation.loc_info && currentLocation.loc_info !== ''" class="sles__active-filter-heading__extra" v-html="currentLocation.loc_info"></div>

                <ClearFiltersButton />
            </div>
        </div>
    </template>
    
    <template v-if="store.currentFilters.session && store.currentFilters.session !== ''" >
        <div class="sles__active-filter-heading sles__active-filter-heading--session">
            <h2 class="sles__active-filter-heading__title">{{ currentSession.title }}</h2>
            <div class="sles__active-filter-heading__info" :class="moderatorsByDay( currentSession.gs_programme ).length > 0 ? 'with-moderators' : ''">

                <div v-if="currentSession.gs_location_name !== ''" class="sles__active-filter-heading__meta">
                    <span class="label">Location</span><span class="value">{{ currentSession.gs_location_roomnumber && currentSession.gs_location_roomnumber !== '' ? currentSession.gs_location_roomnumber + ' - ' : ''}}{{ currentSession.gs_location_name }}</span>
                </div>

               <div v-if="moderatorsByDay( currentSession.gs_programme ).length > 0" class="sles__active-filter-heading__meta sles__active-filter-heading__meta--moderators">
                    <span class="label">{{ moderatorsByDay( currentSession.gs_programme ).length > 1 ? 'Moderators' : 'Moderator'}}</span>
                    <span class="value">
                        <span v-for="(moderator, index) in moderatorsByDay( currentSession.gs_programme )" :key="index" class="moderator">
                            <span class="label">- {{moderator.day}} {{moderator.start}}:</span>
                            <span class="value">{{moderator.moderators}}</span>
                        </span>
                    </span>
                </div>

                <div v-if="currentSession.gs_extra_info && currentSession.gs_extra_info !== ''" class="sles__active-filter-heading__extra" v-html="currentSession.gs_extra_info"></div>

                <ClearFiltersButton />
            </div>
        </div>
    </template>

    <template v-if="store.currentFilters.workshop && store.currentFilters.workshop !== ''" >
        <div class="sles__active-filter-heading sles__active-filter-heading--ws">
            <h2 class="sles__active-filter-heading__title">{{ currentWorkshop.title }}</h2>
                <div class="sles__active-filter-heading__info">

                <div v-if="currentWorkshop.ws_location_name !== ''" class="sles__active-filter-heading__meta">
                    <span class="label">Location</span><span class="value">{{ currentWorkshop.ws_location_roomnumber && currentWorkshop.ws_location_roomnumber !== '' ? currentWorkshop.ws_location_roomnumber + ' - ' : ''}}{{ currentWorkshop.ws_location_name }}</span>
                </div>

                <div v-if="currentWorkshop.ws_convenors !== ''" class="sles__active-filter-heading__meta">
                    <span class="label">Convenors</span><span class="value">{{ currentWorkshop.ws_convenors }}</span>
                </div>

                <div v-if="currentWorkshop.ws_extra_info && currentWorkshop.ws_extra_info !== ''" class="sles__active-filter-heading__extra" v-html="currentWorkshop.ws_extra_info"></div>

                <ClearFiltersButton />
            </div>
        </div>
    </template>

</template>
